





























import { Component, Vue, Inject, Watch, Ref } from 'vue-property-decorator';

import EditMovimento from './movimento/EditMovimento.vue';
import store, { State } from '@/store';
import { BModalComponent } from 'buefy/types/components';
import { CrudService } from '@/data/services/crud.service';
import CassaList from './CassaList.vue';
import CassaFilter from './CassaFilter.vue';
import { Movement } from '@/data/models/movimento.model';
import { Search } from '@/data/models/search.model';
import { download } from '@/data/utils/helper';

@Component({
	components: {
		CassaList,
		CassaFilter,
		EditMovimento
	},
})
export default class Cassa extends Vue {
	@Inject('CrudService') crudService!: CrudService<Movement>;

	@Ref('list') list!: CassaList;
	@Ref('filter') filter!: CassaFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadCassa();
	}

	onExport(event: Search) {
		this.crudService.csvExport('movement', event, event.page).then(data => {
			const date = new Date();
			download(data, `export-cassa-${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}${date.getHours()}${date.getMinutes()}.csv`);
		});
	}

	saveMovimento(value: Movement, modal: BModalComponent) {
		value.hqid = this.state.headquarter!.id;
		this.crudService.createEntity(Movement, 'movement', value)
			.then(() => {
				this.list.loadCassa();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	addMovimento() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditMovimento,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Movement) => {
					this.saveMovimento(value, modal);
				}
			}
		});
	}

	editMovimento(item: Movement) {
		this.openMovimento(item);
	}

	openMovimento(item: Movement) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditMovimento,
			props: {
				movement: item
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Movement) => {
					this.saveMovimento(value, modal);
				}
			}
		});
	}

	deleteMovimento(item: Movement) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-movement-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Movement, 'movement', item)
					.then(() => {
						this.list.loadCassa();
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			}
		});
	}

}
